import React, { useState } from 'react';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import "./style.sass";

import CardSelector from '../../components/CardsSelector';
import TextEditor from '../../components/Editor/TextEditor';
import { BirthdayCards } from '../../utils/cards-catalog';

const GreetingFormPanel = (props) => {
    const { show, onClose, onSend, sendStatus } = props;

    let selectedCard = BirthdayCards.cards[0].file

    const [cardMessage, setCardMessage] = useState("Happy Birthday!")
    const [selectedTab, setSelectedTab] = useState(0)

    let cardBody = '', headerButton = '', footerButton = ''

    const onChangeTab = (index) => {
        if (index !== selectedTab) {
            setSelectedTab(index)
        }
    }

    if (sendStatus === 'sending') {
        cardBody = (
            <LoadingSpinner
                loaderColor='#00d1b2'
                loaderType='ThreeDots'
                message="Sending"
                messageClassName="is-size-5 subtitle" />
        )
    } else {
        headerButton = (
            <button
                className="delete" aria-label="close"
                onClick={() => onClose()}></button>
        )

        footerButton = (
            <button
                className="button has-text-weight-bold is-fullwidth is-primary"
                onClick={() => onSend(selectedCard, cardMessage)} >Send</button>
        )

        cardBody = (
            <>
                <div className={"tabs px-4 has-text-centered is-small is-toggle is-fullwidth is-marginless"}>
                    <li className={selectedTab === 0 ? 'is-active' : ''} onClick={() => onChangeTab(0)}>
                        <a href="#cover">Cover</a>
                    </li>
                    <li className={selectedTab === 1 ? 'is-active' : ''} onClick={() => onChangeTab(1)}>
                        <a href="#message">Message</a>
                    </li>
                </div>

                <div className={selectedTab === 0 ? 'show-tab' : 'hide-tab'}>
                    <p className="is-size-6 has-text-centered pt-2">Choose card</p>
                    <CardSelector
                        cardsCatalog={BirthdayCards}
                        onCardSelected={(selected) => selectedCard = selected}
                    />
                </div>

                <div className={selectedTab === 1 ? 'show-tab' : 'hide-tab'}>
                    <p className="is-size-6 has-text-centered pt-2 pb-2">Your message</p>
                    <TextEditor
                        disableFontSize
                        initialValue={cardMessage}
                        onChange={(c) => setCardMessage(c)}
                        placeholder="Your message" />
                </div>

            </>        
        )
    }

    return (
        <div className={`modal greeting-modal ${show ? `is-active` : ''}`}>
            <div className="modal-background"></div>

            <div className="modal-card">
                <div className="modal-card-head" >
                    <p className="modal-card-title has-text-centered" style={{ letterSpacing: "0.1em" }}>Greeting Card</p>
                    {headerButton}
                </div>

                <section className="modal-card-body">
                    {cardBody}
                </section>

                <footer className="modal-card-foot">
                    <div className="buttons has-justify-content-centered has-fullwidth">
                        {footerButton}
                    </div>
                </footer>
            </div>


        </div>


    )
}

export default GreetingFormPanel;